import { forwardRef, useCallback, useImperativeHandle, useState } from "react";
import { TextField, Typography } from "@mui/material";

import { useTraining } from "../../contexts/training";
import ModalComponent from "../modal";
import Button from "../button";
import DatePicker from "../date-picker";

export interface ITrainingDueDateModalMethods {
  handleOpen: () => void;
}

const TrainingDueDateModal = forwardRef<ITrainingDueDateModalMethods>(
  (_, ref) => {
    const { training, handleSaveTrainingSheet, saving } = useTraining();
    const [open, setOpen] = useState(false);
    const [teacher, setTeacher] = useState<string>(training?.teacher || "");
    const [trainingDueDate, setTrainingDueDate] = useState<number>();
    const [haveFocusInSomeInput, setHaveFocusInSomeInput] = useState(false);

    const handleCloseModal = useCallback(() => {
      if (!saving) {
        setOpen(false);
        setHaveFocusInSomeInput(false);
      }
    }, [saving]);

    const handleOpen: ITrainingDueDateModalMethods["handleOpen"] =
      useCallback(() => {
        setOpen(true);
        setTeacher(training?.teacher || "");
        setTrainingDueDate(training?.trainingDueDate);
      }, [training]);

    useImperativeHandle(ref, () => ({ handleOpen }));

    return (
      <ModalComponent
        title="Training modal component"
        open={open}
        handleClose={() => (!haveFocusInSomeInput ? handleCloseModal() : {})}
      >
        <Typography>Professor(a)</Typography>
        <TextField
          value={teacher}
          onChange={(e) => setTeacher(e.target.value)}
          sx={{ mt: 1, mb: 3 }}
          inputProps={{
            placeholder: "Quem planejou este treino?",
          }}
          size="small"
        />
        <Typography>Data final do treino</Typography>
        <DatePicker
          slotProps={{
            textField: {
              error: false,
              size: "small",
              sx: { mt: 1, mb: 3, width: "100%" },
            },
          }}
          disabled={saving}
          defaultValue={trainingDueDate}
          onChange={(value) => {
            setTrainingDueDate(value?.getTime() || "");
          }}
        />

        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={() =>
            handleSaveTrainingSheet(
              {
                teacher,
                trainingDueDate,
              } as never,
              handleCloseModal
            )
          }
          loading={saving}
          loadingText="Salvando..."
        >
          Salvar
        </Button>
        <Button
          sx={{ mt: 1 }}
          fullWidth
          variant="text"
          size="large"
          onClick={handleCloseModal}
          disabled={saving}
        >
          Voltar
        </Button>
      </ModalComponent>
    );
  }
);

export default TrainingDueDateModal;
